<template>
  <b-overlay :show="loading" class="animated">
    <v-server-table
      id="test-workflow-task-server-table"
      :ref="ref"
      :columns="table_config.columns"
      :options="table_config.options"
      :theme="theme"
      class="w-100"
    >

      <span slot="name" slot-scope="{row}">
        <b-link :to="`/${route_root}/${sample_type_id}/${test_process_id}/${row.id}`">
          {{ row.name }}
        </b-link>
      </span>

      <span slot="parent" slot-scope="{row}">
        <template v-if="row.parent">
          {{ row.parent.name }}
        </template>
      </span>

      <span slot="group" slot-scope="{row}">
        <i v-if="row.group" class="fa fa-check text-success" />
        <i v-else class="fa fa-times text-muted" />
      </span>

      <span slot="actions" slot-scope="{ row }">
        <b-button v-if="checkPermission('edit test task')" :to="`/${route_root}/${sample_type_id}/${test_process_id}/${row.id}/edit`" variant="warning" class="px-1 py-0 text-white mr-1">
          <i class="fa fa-pencil" />
        </b-button>
      </span>

    </v-server-table>
  </b-overlay>
</template>

<script>
import Vue from 'vue'
import { ServerTable } from 'vue-tables-2'
import BaseServerTable from '@/components/shared/BaseServerTable'
import { AccessControlCheck } from '@/auth/AccessControlCheck'
import TestTaskCollection from '@/collections/lab/TestTaskCollection'
import { TestWorkflowRoutes } from '@/router/lab/TestWorkflowRoutes'

Vue.use(ServerTable)

export default {
  name: 'WorkflowTestServerTable',
  extends: BaseServerTable,
  props: {
    collection: {
      type: Object,
      default: () => new TestTaskCollection()
    },
    sample_type_id: {
      type: String,
      default: null
    },
    test_process_id: {
      type: String,
      default: null
    },
    show_columns: {
      type: Array,
      default: () => [
        'name',
        'parent',
        'group',
        'actions'
      ]
    }
  },
  data () {
    return {
      table_config: Object.assign(this.getDefaultTableConfig(), {
        options: {
          headings: {
            name: 'Name',
            actions: 'Actions'
          }
        }
      })
    }
  },
  computed: {
    route_root () {
      return TestWorkflowRoutes.fetchRoot()
    }
  },
  methods: {
    checkPermission (permission) {
      return AccessControlCheck.checkPermission(permission)
    },

    prepareCollectionFilter(filter) {
      filter.filterEquals('test_process_id', this.test_process_id)
    }
  }
}
</script>
